
// Calculate the percentage for forecast and actual values
export function calculatePercentageAccuracy(actual, forecast) {
    if (actual === 0) {
        return 0;
    }
    
    // Calculate the absolute difference between the actual and forecast values
    let difference = Math.abs(actual - forecast);
    
    // Divide the absolute difference by the actual value
    let ratio = difference / actual;
  
    // Subtract this ratio from 1 to get the accuracy
    let accuracy = 1 - ratio;
  
    // Convert the accuracy to a percentage
    let percentageAccuracy = accuracy * 100;
    
    return percentageAccuracy;
}

export function calculateAPE(real, forecasted) {
    if (real === 0) {
        return 0;
    }
    
    const absoluteError = Math.abs(real - forecasted);
    const relativeError = absoluteError / real;
    const APE = relativeError * 100;
    
    return APE;
}